import React from "react"
import {Editable, EditableBooleanField} from "../HorizontalField/EditableHorizontalField"

export interface EditableIsIncorporatedProps {
	isIncorporated?: boolean
	setIsIncorporated: (value: boolean) => void
	isEditing: boolean
	isDisabled: boolean
	isAllowed: boolean
	isUpdating: boolean
	onStartEdit: () => void
	onCancel: () => void
	update: (value: boolean) => void
	className?: string
}

export function EditableIsIncorporatedField(props: EditableIsIncorporatedProps) {
	if (props.isIncorporated === undefined) {
		return null
	}

	return (
		<Editable
			label="Is Incorporated"
			isEditing={props.isEditing}
			isDisabled={props.isDisabled}
			isAllowed={props.isAllowed}
			onStartEdit={props.onStartEdit}
			onCancel={props.onCancel}
			setValue={props.setIsIncorporated}
			value={props.isIncorporated}
			initial={props.isIncorporated}
			update={props.update}
			className={props.className}
		>
			{EditableBooleanField}
		</Editable>
	)
}
